import { setTextOverflow } from 'polotno/config';

/**
 * Text layers fed by dynamic data (listing fields, merge tags, brand values) hold copy that is
 * routinely longer than the placeholder text a template was designed around. `change-font-size`
 * shrinks such a layer's font until the text fits the box it was given, instead of cutting it off
 * (`ellipsis`) or letting the box grow over the rest of the design (`resize`, Polotno's default).
 *
 * It also matches the back-end rasterizer, which fits text the same way. The two disagreeing is
 * what made a postcard print smaller than it looked in the editor (Monday 13018426671).
 *
 * Polotno keeps this flag in one module-level observable per bundle, not per store, so it has to
 * be set once at an entry point rather than next to any single `createStore` call — every store in
 * the bundle reads the same flag.
 */
setTextOverflow('change-font-size');
